export default __webpack_public_path__ + "static/media/p9.2d7ac014.JPG";